import { gql } from "@apollo/client";
import { BACKEND_HAS_CANCELLED_STATUS } from "../databucket";

// Empty until the backend serving these fields is deployed — a field the
// schema doesn't know about fails the whole query with HTTP 400.
const CANCELLED_EMP_FIELD = BACKEND_HAS_CANCELLED_STATUS ? "cancelledRequests" : "";
const CANCELLED_TEAM_FIELD = BACKEND_HAS_CANCELLED_STATUS ? "totalRequestsCancelled" : "";

export const GET_OPERATIONS_DASHBOARD = gql`
  query GetOperationsDashboard($userId: String, $department: String, $view: String, $employeestatus: String, $date: String, $loginUserId: String) {
    getOperationsDashboard(userId: $userId, department: $department, view: $view, employeestatus: $employeestatus, date: $date, loginUserId: $loginUserId) {
      employees {
        userId
        employeeName
        empId
        email
        department
        designation
        reportingManager
        shiftInTime
        shiftOutTime
        employeestatus
        clients
        currentStatus
        loginTime

        hoursToday
        hoursThisWeek
        hoursThisMonth
        hoursThisYear

        productiveToday
        nonProductiveToday
        productiveThisWeek
        nonProductiveThisWeek
        productiveThisMonth
        nonProductiveThisMonth

        taskBreakdown {
          taskType
          totalSeconds
          totalHours
          sessionCount
        }
        sourceBreakdown {
          taskType
          totalSeconds
          totalHours
          sessionCount
        }
        autoDetectionRate

        totalActive
        totalIdle
        activityProductive
        activityUnproductive
        focusSwitches
        breakCount
        topApps {
          name
          duration
        }
        topBrowserDomains {
          domain
          duration
        }

        totalRequests
        completedRequests
        pendingRequests
        onHoldRequests
        ${CANCELLED_EMP_FIELD}
        emailNeededRequests

        clientWorkDistribution {
          clientName
          hours
          requestCount
        }

        totalLeaves
        usedLeaves
        availableLeaves
        medicalLeavesAvailable
        annualLeavesAvailable
      }
      teamSummary {
        totalMembers
        presentToday
        onLeaveToday
        absentToday
        avgHoursToday
        totalProductiveToday
        totalNonProductiveToday
        totalRequestsCompleted
        totalRequestsPending
        ${CANCELLED_TEAM_FIELD}
      }
      totalCount
    }
  }
`;
